<template>
    <div class="d-flex gap-x-1 align-items-start comment-root p-3 border-bottom position-relative">
        <div>
            <img v-if="comment.user.profile_picture" class="rounded-circle" width="30" height="30" :src="comment.user.profile_picture?.full_url || urlGenerator('/images/avatar-demo.jpg')" :alt="comment.user.full_name">
            <div v-else class="no-img rounded-circle" style="height: 30px; width: 30px;">{{ comment.user.full_name ? nameText(comment.user.full_name) : 'AV' }}</div>
        </div>
        <div class="flex-fill">
            <div>{{ comment.comment }}</div>
            <div class="d-flex gap-x-1">
                <small @click="reaction" class="reaction rounded-pill" :class="reacted ? 'text-primary' : ''"><app-icon :size="12" name="thumbs-up" /><span class="ml-2">{{ reactions_count }}</span></small>
                <template v-if="commentable">
                    <small v-if="!isReplyExpanded" class="reaction rounded-pill text-primary" @click="reply">{{$t('reply')}} {{ comments.replay_count ? comments.replay_count : '' }}</small>
                </template>
                <template v-if="Number(comment.user_id) === Number(loginUser.id)">
                    <small class="reaction rounded-pill text-danger" @click="wannaDel = true"><app-icon :size="16" name="trash" /></small>
                </template>
            </div>
            <div v-if="isReplyExpanded">
                <div v-if="comments.data.length" class="d-flex flex-column">
                    <comment v-for="(comment, index) in comments.data" :commentable="false" :comment="comment" @del="delComment" :key="`reply-${comment.id}-comment-item-${index}`" />
                </div>
                <div v-if="commentable" class="d-flex justify-content-center position-relative">
                    <button v-if="more_comment" @click="getComment" class="btn btn-link p-0">{{ $t('more_reply') }}</button>
                </div>
                <div v-if="comments.recentData.length" class="d-flex flex-column">
                    <comment v-for="(comment, index) in comments.recentData" :comment="comment" :key="`${comment.id}-comment-recent-item-${index}`" :commentable="false" @del="delComment" />
                </div>
                <new-comment v-if="commentable" class="mt-2" @submit="submitComment" :id="comment.id" :submitting="submitting" />
            </div>
        </div>
        <confirm v-if="wannaDel" @cancel="wannaDel = false" @confirm="del" :loading="loading" />
    </div>
</template>

<script>
import NewComment from "./NewComment";
import axios from "axios";
import Comment from "./Comment";
import {COMMENT_REPLIES, POST_COMMENT, POSTS, REPLY_COMMENT} from "../../../../config/ApiUrl";
import {urlGenerator} from "../../../../helpers/AxiosHelper";
import Confirm from "../others/Confirm";
export default {
    name: 'Comment',
    props: {
        comment: {},
        commentable: {
            default: true,
        }
    },
    components: { NewComment, Confirm },
    data() {
        return {
            urlGenerator,
            wannaReply: false,
            isReplyExpanded: false,
            comment_options: {
                page: 1,
                per_page: 3
            },
            more_comment: false,
            submitting: false,
            comments: {
                data: [],
                recentData: [],
                replay_count: 0
            },
            reactions_count: 0,
            reacted: false,
            loginUser: window.user,
            wannaDel: false,
            loading: false
        }
    },
    methods: {
        reaction() {
            let url = this.commentable ? REPLY_COMMENT+this.comment.id+'/react' : COMMENT_REPLIES+this.comment.id+'/react';

            axios.post(urlGenerator(url), { reaction: '👍' }).then(res => {
                this.reacted = res.data.data.reacted
                this.reactions_count = res.data.data.reactions_count
            }).finally(() => {})
        },
        submitComment(event) {
            this.submitting = true
            axios.post(urlGenerator(REPLY_COMMENT + this.comment.id + '/comment-replies'), {comment: event.target.content.value}).then(res => {
                this.comments.recentData.push(res.data.reply)
                this.comments.replay_count = Number(this.comments.replay_count) + Number(1)
            }).catch(err => {
            }).finally(() => {
                this.submitting = false
            })
        },
        nameText(full_name) {
            return full_name.split(' ').map(i => i[0].toUpperCase()).join('')
        },
        reply() {
            if(!this.isReplyExpanded) {
                this.getComment()
            }
            this.isReplyExpanded = true
        },
        getComment(previous_data = false) {
            axios.get(urlGenerator(REPLY_COMMENT+this.comment.id+'/comment-replies'), { params: this.comment_options }).then((res) =>{
                this.comments.data = [...this.comments.data, ...res.data.data]
                this.more_comment = this.comment_options.page < res.data.last_page
                this.comment_options.page += 1
            }).finally(() => {
                setTimeout(() => {
                }, 500)
            })
        },
        delComment(id) {
            this.comments.data = this.comments.data.filter(i => i.id !== id)
            this.comments.recentData = this.comments.recentData.filter(i => i.id !== id)
            this.comments.replay_count = Number(this.comments.replay_count) - Number(1)
        },
        del() {
            this.loading = true
            let url = ''
            if(this.commentable){
                url = urlGenerator(POST_COMMENT + this.comment.post_id + '/post-comments/' + this.comment.id)
            }else{
                url = urlGenerator(REPLY_COMMENT + this.comment.comment_id + '/comment-replies/' + this.comment.id)
            }
            axios.delete(url).then(res => {
                this.$toastr.s(res.data.message)
                this.$emit('del', this.comment.id)
            }).catch((err) => {})
                .finally(() => { this.loading = false })
        }
    },
    mounted() {
        this.reactions_count = this.comment.reactions_count
        this.reacted = this.comment.reacted
        this.comments.replay_count = this.comment.replies_count
    }
}
</script>

<style scoped lang="scss">
.comment-root{
    &:focus-within{
        background-color: #0c546010;
    }
}
.reaction{
    border: none;
//border-radius: 5px;
    padding: 3px 15px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #0c546010;
&:hover{
     background-color: #0c546030;
 }
}
.no-img {
    background-color: #0c546010;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999999
}
</style>